<template>
  <div class="filebackup-detail">
    <div class="checker-main" v-if="permission">
      <span class="tag-group__title">交接人员：</span>
      <el-tag
        :key="tag"
        v-for="tag in checker"
        closable
        size="medium"
        :disable-transitions="false"
        @close="handleClose(tag)">
        {{tag}}
      </el-tag>
      <el-input
        class="input-new-tag"
        v-if="inputVisible"
        v-model="inputValue"
        ref="saveTagInput"
        size="small"
        @keyup.enter.native="handleInputConfirm"
        @blur="handleInputConfirm"
      >
      </el-input>
      <el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Tag</el-button>
    </div>
    <c-table
      ref="table"
      :fields="fields"
      :columns="columns"
      url="filebackup/home2"
      :fetchPage="true"
      @before-fetch="beforeFetch"
      @after-fetch="afterFetch"
    >
      <el-table-column slot="path" label="文件路径">
        <template v-slot="{row}">
          <el-button type="text" @click="download(row)">{{row.path}}</el-button>
        </template>
      </el-table-column>
      <el-table-column slot="size" label="文件大小">
        <template v-slot="{row}">
          {{row.size | formatSize}}
        </template>
      </el-table-column>
    </c-table>
  </div>
</template>

<script>
import CTable from '@/components/common/table'
import mixin from '@/mixins'

export default {
  name: 'file-detail',
  mixins: [ mixin ],
  components: { CTable },
  data () {
    return {
      fields: [
        {
          prop: 'search',
          placeholder: '文件名',
          clearable: true
        }],
      columns: [
        { prop: 'fileid', label: '文件ID', width: 100 },
        { slot: 'path' },
        { slot: 'size' }
      ],
      fileId: location.href.split('/')[location.href.split('/').length - 1],
      permission: false,
      checker: [],
      inputVisible: false,
      inputValue: ''
    }
  },
  created() {
    this.id = this.$route.params.id
  },
  filters: {
    formatSize: function (value) {
      if (!value) return ''
      const units = ['字节', 'KB', 'MB', 'G', 'T']
      let result = value
      const fixed = val => {
        return /\.\d{3,}/.test(val) ? val.toFixed(2) : val
      }
      units.every(unit => {
        const temp = result / 1024
        if (result >= 1024 && temp >= 1024) {
          result = temp
          return true
        } else if (result < 1024) {
          result = fixed(result) + ' ' + unit
          return false
        } else {
          result = fixed(temp) + ' ' + unit
          return false
        }
      })
      return result
    }
  },
  methods: {
    download (row) {
      this.$notify.success({
        title: '正在下载...',
        message: row.path
      })
      this.$http.post(`/filebackup/get`, {
        fileid: row.fileid
      }, {
        responseType: 'blob'
      }).then(res => {
        let link = document.createElement('a')
        let evt = document.createEvent('HTMLEvents')
        evt.initEvent('click', false, false)
        link.href = URL.createObjectURL(res.data)
        link.download = row.path
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
      })
    },
    beforeFetch(data) {
      if (this.fileId) {
        data.id = this.fileId
      }
    },
    afterFetch(res) {
      this.permission = res.data.previllage === 10
      this.checker = res.data.checker
    },
    handleClose(name) {
      this.$http.post('/filebackup/deletecheck', {
        name,
        id: this.id
      }).then(res => {
        res.successful && this.checker.splice(this.checker.indexOf(name), 1)
      })
    },

    showInput() {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },

    handleInputConfirm() {
      let name = this.inputValue
      if (this.checker.includes(name)) {
        this.$notify.error({
          title: '错误',
          message: '名字已存在，不可重复添加'
        })
        return
      }
      if (name) {
        this.$http.post('/filebackup/addcheck', {
          name,
          id: this.id
        }).then(res => {
          res.successful && this.checker.push(name)
        })
      }

      this.inputVisible = false
      this.inputValue = ''
    }
  }
}
</script>

<style lang="scss">
.filebackup-detail{
  .c-table{
    padding-top:10px;
  }
  .checker-main{
    padding: 20px 20px 0;
    background: #fff;
    display: flex;
    align-items: center;
    .tag-group__title{
      color: #606266;
      font-size: 14px;
    }
    .el-tag + .el-tag {
      margin-left: 10px;
    }
    .button-new-tag {
      margin-left: 10px;
      height: 32px;
      line-height: 30px;
      padding-top: 0;
      padding-bottom: 0;
    }
    .input-new-tag {
      width: 90px;
      margin-left: 10px;
      vertical-align: bottom;
    }
  }
}
</style>
